import { FormControl } from "@material-ui/core";
import { MenuItem, Select, Typography } from "@mui/material";
import { MapContext } from "../../../contexts/MapFilterContext";
import { useContext } from "react";
import DropdownIcon from "../../DropdownIcon";
import { classes } from "../classes";

export default function Status() {
    const {
        status, setStatus,
        statusesList
    } = useContext(MapContext);

    return (
        <>
            <Typography style={classes.labelInput}>
                Status dos itens exibidos:
            </Typography>
            <FormControl variant="outlined" style={classes.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    value={status}
                    onChange={(e) => { setStatus(e.target.value); }}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value={"Todos"}>Todos</MenuItem>
                    {
                        statusesList.map((status) => (
                            <MenuItem key={status.id} value={status.name}>{status.name}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        </>
    )
}